<template >
  <div id="ravenwareSite"  ref="ravenwareSite" :style="userStyle">

    <div id="site-header">
      <div class="row">
        <div class="col-md-3" id="site-logo-wrap">
          <a href="/"><img src="resources/images/logos/uk_business_broadband_x300.png" alt="UK Business Broadband Logo" id="site-logo"></a>
          <p id="associated">Part of <a href="https://ukitnetworks.com/" target="_blank"><img src="resources/images/logos/uk_it_networks_x100.png" alt="UK IT Networks" id="associated-logo"></a></p>
        </div>
        <div class="col-md-9 menu-items">
          <div class="items">
            <a href="/home">Business Broadband</a>
            <a href="/ethernet">Leased Line</a>
            <a href="/about-us">About Us</a>
            <a href="/support">Help and Support</a>
            <a href="/partners">Partners</a>
          </div>
          <a href="/support" class="btn btn-ukit-secondary">Contact Us</a>
        </div>
      </div>
    </div>

    <div id="background-outer" style="background-image:url('resources/images/ukit_networks_business_broadband.png');">
      <div id="background-inner">

        <div id="site-hero">
          <h1>Ethernet Leased <br>Line Deals</h1>
          <h2>Compare the latest <span>high speed</span> Ethernet<br>deals available to UK businesses</h2>
          <h3>Enter Your Details To Get Started</h3>
        </div>

        <div id="greenFrame" ref="greenFrame">
          <div v-if="isLoading" id="loading" style="width: 100%;height: 100%;z-index: 2000;position: absolute;top: 0px;left: 0px;padding: 50px;">
            <loading :active.sync="isLoading" :can-cancel="false" :color="'#B9D253'" :is-full-page="false"></loading>
          </div>
          <div class="text-center pt-4" v-if="!searchData.tid">
            <p>No TID provided</p>
          </div>
          <div v-if="searchData.tid">
            <div class="wizardski">

              <div id="thankyou" class="text-center" v-if="stage === 'thankyou'"  >
                <div class="row">
                  <div class="col-md-10 offset-md-1">
                    <h4>Thank you for placing your business with UK IT Networks Limited for {{ order.selectedQuote.productName }}.</h4>
                    <p>An email has been sent to {{ order.emailAddress }} to confirm your order.</p>
                    <p>Your order for services will be reviewed for acceptance and then processed within the next business day. Once validated we will confirm that we have accepted your order. Any questions please dont hesitate to call us on:  <strong class="text-ukit-primary">0344 326 2154</strong></p>
                  </div>
                </div>
              </div>

              <div id="wizardski" class="" v-if="stage == 'order'">
                <div class="row">
                  <div class="col-md-8">
                    <v-stepper v-model="currentStep">
                      <v-stepper-header>
                        <v-stepper-step :complete="e1 > 1" step="1" > <span class="ml-2">Your Details</span></v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="e1 > 2" step="2" > <span class="ml-2">Installation</span></v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="e1 > 3" step="3" > <span class="ml-2">Confirm Order</span></v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step step="4"> <span class="ml-2">Agreement</span></v-stepper-step>
                      </v-stepper-header>
                      <v-stepper-items>
                        <v-stepper-content step="1">
                          <div>
                            <v-form ref="detailsForm" lazy-validation v-model="detailsFormValid" class="bbc_zeroTop">
                              <v-container class="bbc_zeroTop">
                                <v-row class="bbc_zeroTop">
                                  <v-col class="bbc_zeroTop" cols="12" md="12">
                                    <div>
                                      <div class="mr-4" style="float:left;">
                                        <h4 v-bind:class="{'text-muted': !order.existingCustomer}">Existing Customer</h4>
                                      </div>
                                      <div class="" >
                                        <a-switch style="margin-top: 5px;" size="small" @change="toggleExistingCustomer()" />
                                        <!-- <v-switch @change="toggleExistingCustomer()"  :label="''" color="success" value="success" hide-details></v-switch> -->
                                      </div>
                                    </div>
                                    <br>
                                    <div v-if="order.existingCustomer === true">
                                      <v-text-field required :rules="requiredRules" filled dense ref="companyName" v-model="order.companyName" label="Company Name" ></v-text-field>
                                      <v-text-field required :rules="requiredRules" filled dense ref="emailAddress" v-model="order.emailAddress" label="Email Address" ></v-text-field>
                                    </div>
                                    <div v-if="order.existingCustomer === false">
                                      <h4 v-bind:class="{'text-muted': order.existingCustomer}">New Customer</h4>
                                      <v-text-field required :rules="requiredRules"  filled dense ref="authorisedContactName" v-model="order.authorisedContactName" label="Name" ></v-text-field>
                                      <v-text-field required :rules="requiredRules" filled dense ref="emailAddress" v-model="order.emailAddress" label="Email Address" ></v-text-field>
                                      <hr>
                                      <v-text-field required :rules="requiredRules" filled dense ref="companyNameNew" v-model="order.companyName" label="Company Name" ></v-text-field>
                                      <v-text-field filled dense ref="accountSite" v-model="order.accountSite" label="Account Site e.g Head Office" ></v-text-field>
                                      <v-text-field required :rules="requiredRules" filled dense ref="phoneNumber" v-model="order.phoneNumber" label="Phone Number" ></v-text-field>
                                      <v-text-field filled dense ref="faxNumber" v-model="order.faxNumber" label="Fax Number" ></v-text-field>
                                      <v-text-field filled dense ref="website" v-model="order.website" label="Website" ></v-text-field>
                                      <v-text-field filled dense ref="numberOfEmployees" v-model="order.numberOfEmployees" label="Number Of Employees" ></v-text-field>
                                      <v-text-field filled dense ref="registeredNumber" v-model="order.registeredNumber" label="Registered Number" ></v-text-field>
                                      <div class="mr-4" style="float:left;">
                                        <h4 v-bind:class="{'text-muted': !order.existingCustomer}">Billing Contact</h4>
                                      </div>
                                      <div>
                                        <v-btn class="float-right" style="margin-top:2px; padding:4px; line-height:5px; height:20px; font-size:10px; color:#fff;" color="#AFCB3A" @click="copyAuthDetailsToAccount()" >Same as Above</v-btn>
                                      </div>
                                      <br>
                                      <v-text-field required :rules="requiredRules" filled dense style="margin-top: 15px;" ref="accountsContactName" v-model="order.accountsContactName" label="Name" ></v-text-field>
                                      <v-text-field  required :rules="requiredRules" filled dense ref="accountsContactEmail" v-model="order.accountsContactEmail" label="Email Address" ></v-text-field>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-form>
                          </div>
                          <div style="margin-top: -30px; margin-right: 12px;" class="float-right">
                            <v-btn class="float-right" style="color:#fff;" color="#AFCB3A" @click="goToInstall()" >Next</v-btn>
                          </div>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                          <div>
                            <h4>Installation Details</h4>
                            <p>To get you set up, we just need a few key details about your business. Please complete the fields below.</p>
                            <v-form ref="installForm" v-model="isValid" class="bbc_zeroTop">
                              <v-container  class="bbc_zeroTop">
                                <v-row  class="bbc_zeroTop">
                                  <v-col class="bbc_zeroTop" cols="12" md="12">
                                    <h5>Address Details</h5>
                                    <v-text-field v-on:keyup="addressChange()" filled dense ref="installAddress" v-model="order.addresses[0].address" label="Address" ></v-text-field>
                                    <v-text-field v-on:keyup="addressChange()" filled dense ref="installStreet" v-model="order.addresses[0].street" label="Street" ></v-text-field>
                                    <v-text-field v-on:keyup="addressChange()" filled dense ref="installCounty" v-model="order.addresses[0].county" label="County" ></v-text-field>
                                    <!-- <v-text-field v-on:keyup="addressChange()"  dense ref="installCountry" v-model="order.addresses[0].country" label="Country" ></v-text-field> -->
                                    <v-text-field v-on:keyup="addressChange()" filled dense ref="installPostcode" v-model="order.addresses[0].postcode" label="Post Code" ></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-form>
                          </div>
                          <div style="margin-top: -30px; margin-right: 12px;" class="float-right">
                            <v-btn class="mr-2" color="#042B56" style="color:#fff;" @click="previousStep()" >Back</v-btn>
                            <v-btn color="#AFCB3A" style="color:#fff;" @click="nextStep()" >Next</v-btn>
                          </div>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                          <v-form lazy-validation ref="installForm" v-model="installFormValid" class="bbc_zeroTop">
                            <v-container class="bbc_zeroTop">
                              <v-row class="bbc_zeroTop">
                                <v-col class="bbc_zeroTop" cols="12" md="12">
                                  <div v-if="!order.selectedQuote.productName.includes('SOGEA')">
                                    <h5>Business Line <small>(Do you have an existing line or would you like to add an additional line)</small></h5>
                                    <v-row>
                                      <v-col cols="12">
                                        <a-select :disabled="true" size="large" default-value="New Line"   @change="lineTypeChange"  v-model="order.orderType">
                                          <a-select-option value="Existing Line">Existing Business Line</a-select-option>
                                          <a-select-option value="New Line">New Business Line</a-select-option>
                                        </a-select>
                                      </v-col>
                                    </v-row>
                                  </div>
                                  <h5>Contract Term <small>(Free Business Line installation on 36 months contracts)</small></h5>
                                  <v-row>
                                    <v-col cols="12">
                                      <a-select @change="termChanged()" size="large" default-value="36 Months"  v-model="order.termLength">
                                        <a-select-option value="12 Months">12 Months</a-select-option>
                                        <a-select-option value="36 Months">36 Months</a-select-option>
                                      </a-select>
                                    </v-col>
                                  </v-row>
                                  <h5>Router</h5>
                                  <v-row>
                                    <v-col cols="12">
                                      <a-select @change="routerChanged" size="large" default-value="Technicolor Wireless"  v-model="order.router">
                                        <a-select-option value="No Router Required">No Router Required £0.00</a-select-option>
                                        <a-select-option value="Technicolor Wired">Technicolor Pre-configured Wired Hardware inc Delivery £47.80</a-select-option>
                                        <a-select-option value="Technicolor Wireless">Technicolor Pre-configured Wireless Hardware inc Delivery £72.59</a-select-option>
                                      </a-select>
                                    </v-col>
                                  </v-row>
                                  <div v-if="order.existingCustomer === false">
                                    <h5>Payment Details <small>(Please enter your Direct Debit details below)</small></h5>
                                    <v-row>
                                      <v-col cols="4">
                                        <v-subheader>Account Number</v-subheader>
                                      </v-col>
                                      <v-col cols="8">
                                        <v-text-field required :rules="requiredRules" filled dense ref="accountNumber" v-model="order.accountNumber" label="Account Number" ></v-text-field>
                                      </v-col>
                                    </v-row>
                                    <v-row>
                                      <v-col cols="4">
                                        <v-subheader>Sort Code</v-subheader>
                                      </v-col>
                                      <v-col cols="8">
                                        <v-text-field required :rules="requiredShort" type="number" class="float-left" style="width:100px;"  append-outer-icon="mdi-minus"   dense ref="sortcode1" v-model="sortcode1" label="" ></v-text-field>
                                        <v-text-field required :rules="requiredShort" type="number" class="float-left" style="width:100px; margin-left: 10px; margin-right: 10px;"  append-outer-icon="mdi-minus"   dense ref="sortcode2" v-model="sortcode2" label="" ></v-text-field>
                                        <v-text-field required :rules="requiredShort" type="number" style="width:65px;" dense ref="sortcode3" v-model="sortcode3" label="" ></v-text-field>
                                      </v-col>
                                    </v-row>
                                    <div class="mr-4" style="float:left;"><h4>Billing Address</h4></div>
                                    <div class="" >
                                      <a-switch  checkedChildren="Same As Install" unCheckedChildren="" size="small" style="margin-top:0px;" v-model="order.billingAddressSameAsInstall" @change="toggleSameBillingAddress()"  />
                                      <!-- <v-switch v-model="order.billingAddressSameAsInstall" @change="toggleSameBillingAddress()"  :label="'Same As Installation'" color="success"></v-switch>  -->
                                    </div>
                                    <div style="margin-top: 20px;" v-if="!order.billingAddressSameAsInstall">
                                      <v-text-field  filled dense ref="billingAddress" v-model="order.addresses[1].address" label="Address" ></v-text-field>
                                      <v-text-field  filled dense ref="billingStreet" v-model="order.addresses[1].street" label="Street" ></v-text-field>
                                      <v-text-field  filled dense ref="billingCounty" v-model="order.addresses[1].county" label="County" ></v-text-field>
                                      <!-- <v-text-field  dense ref="billingCountry" v-model="order.addresses[1].country" label="Country" ></v-text-field> -->
                                      <v-text-field  filled dense ref="billingPostcode" v-model="order.addresses[1].postcode" label="Post Code" ></v-text-field>
                                    </div>
                                    <div style="margin-top: 20px;" v-if="order.billingAddressSameAsInstall">
                                      {{ order.addresses[0].address }} {{ order.addresses[0].street }} {{ order.addresses[0].county }} {{ order.addresses[0].postcode }}
                                    </div>
                                  </div>
                                </v-col>
                              </v-row>
                              <hr>
                              <v-row>
                                <v-col>
                                  <h5>Direct Debit Guarantee</h5>
                                  <p style="font-size:12px; color: #000;">This Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits.<br>If there are any changes to the amount, date or frequency of your Direct Debit, UKIT Networks will notify you three working days in advance of your account being debited or as otherwise agreed. If you request UKIT Networks to collect a payment, confirmation of the amount and date will be given to you at the time of the request.<br>If an error is made in the payment of your Direct Debit by UKIT Networks or your bank or building society you are entitled to a full and immediate refund of the amount paid from your bank or building society.<br>If you receive a refund you are not entitled to, you must pay it back when UKIT Networks asks you to. You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify us.</p>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                          <div style="margin-top: -30px; margin-right: 12px;" class="float-right">
                            <v-btn class="mr-2" color="#042B56" style="color:#fff;" @click="previousStep()" >Back</v-btn>
                            <v-btn color="#AFCB3A" style="color:#fff;" @click="gotToAgreement()" >Next</v-btn>
                          </div>
                          <!-- <div style="margin-top: -30px; margin-right: 12px;" class="float-right">
                            <v-btn class="mr-2" color="#042B56" style="color:#fff;" @click="previousStep()" >Back</v-btn>
                            <v-btn color="#AFCB3A" style="color:#fff;" @click="completeOrder()" >Finish</v-btn>
                          </div> -->
                        </v-stepper-content>

                        <v-stepper-content step="4">
                          <div>
                            <p class="text-center">By clicking Confirm Order, I agree to the terms and conditions (UK IT Networks Limited Terms & Conditions v2.2) set out on your website <a href="https://ukitnetworks.com/terms-and-conditions" target="_blank">ukitnetworks.com/terms-and-conditions</a>, confirm that the information on this broadband order is correct, and I am authorised to sign for and behalf of {{ order.companyName }}. Until we notify you to the contrary, you may contact us by letter, telephone, fax, e-mail, sms or any other electronic means with regards to products and services offered by UK IT Networks Limited.</p>
                            <div class="row">
                              <div class=" col-md-12">
                                <div @scroll="handleScroll" class="tsAndCsContainer">
                                  <div style="position: absolute;top: -10px;right: 15px;z-index: 6000;">
                                    <span class="text-ukit-primary">Scroll Down To Agree to Ts and Cs</span> <i class="fa fa-arrow-down"></i>
                                  </div>
                                  <termsandconditions></termsandconditions>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-12 text-center">
                              <button v-if="!hasScrolledToBottom" disabled="disabled" class="disabled btn ">Agree To Terms</button>
                              <button v-on:click="completeOrder()" v-if="hasScrolledToBottom" class="btn btn-ukit-primary">Agree To Terms</button>
                            </div>
                          </div>
                        </v-stepper-content>
                      </v-stepper-items>
                    </v-stepper>
                  </div>
                  <div class="col-md-4 pr-4">
                    <div class="card p-2">
                      <h4 class="text-ukit-primary text-center">Your Order</h4>
                      <table class="table table-striped">
                        <tbody>
                          <tr>
                            <td>{{ order.selectedQuote.productName }}</td>
                            <td>£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.broadbandMonthlyRental) }}</td>
                          </tr>
                          <tr v-if="order.selectedQuote.pricing.businessLineRentalRequired || order.selectedQuote.productName.includes('SOGEA')">
                            <td>Installation</td>
                            <td v-if="order.termLength === '36 Months'" class="text-ukit-primary">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.newBusinessLineInstallation36MONTHSCost) }}</td>
                            <td v-if="order.termLength === '12 Months'" class="text-ukit-primary">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.newBusinessLineInstallation12MONTHSCost) }}</td>
                          </tr>
                          <tr v-if="order.selectedQuote.pricing.businessLineRentalRequired">
                            <td>Business Monthly Line Rental</td>
                            <td class="text-ukit-primary">£{{ order.selectedQuote.pricing.businessLineRentalCost }}</td>
                          </tr>
                          <tr v-if="order.selectedQuote.pricing.businessLineRentalRequired">
                            <td>Discounted Business Calls*</td>
                            <td class="text-ukit-primary">INCLUDED</td>
                          </tr>
                          <tr>
                            <td>Static IP</td>
                            <td class="text-ukit-primary">INCLUDED</td>
                          </tr>
                          <tr v-if="order.orderType === 'Existing Line' || order.selectedQuote.pricing.broadbandConnectionCost != 0">
                            <td>Connection Fee</td>
                            <td class="text-ukit-primary">£{{ toTwoDecimalPlaces(order.selectedQuote.pricing.broadbandConnectionCost) }}</td>
                          </tr>
                          <tr v-if="order.router != 'No Router Required'">
                            <td>Router</td>
                            <td class="text-ukit-primary">£{{ toTwoDecimalPlaces(order.routerCost) }}</td>
                          </tr>
                          <tr v-if="order.orderType !== 'Existing Line'">
                            <td>Migration Fee</td>
                            <td class="text-ukit-primary">INCLUDED</td>
                          </tr>
                          <tr>
                            <td v-if="order.selectedQuote.pricing.businessLineRentalRequired" colspan="2">*Business Voice Calls - (0.72 pence per minute to UK Local and National and 1.95 pence per minute to UK Mobiles)</td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="table">
                        <tbody>
                          <tr>
                            <td>One Off Total excl VAT</td>
                            <td>£{{ toTwoDecimalPlaces(order.totalOneOffCost) }}</td>
                          </tr>
                          <tr>
                            <td>Monthly Total excl VAT</td>
                            <td>£{{ toTwoDecimalPlaces(order.totalMonthlyCost) }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <h4 class="text-ukit-primary text-center">{{ order.selectedQuote.productName }}</h4>
                      <div class="row text-center">
                        <div class="col-md-6">
                          <strong>Download</strong><br>
                          <span v-if="order.selectedQuote.productSpeed.estimatedDownloadRange.includes('-')">
                            <small>From: {{ formatHyphenatedMinToMbps(order.selectedQuote.productSpeed.estimatedDownloadRange) }} to</small>
                            <h3 class="text-ukit-primary">{{ formatHyphenatedMaxToMbps(order.selectedQuote.productSpeed.estimatedDownloadRange) }}</h3>
                          </span>
                          <span v-if="!order.selectedQuote.productSpeed.estimatedDownloadRange.includes('-')">
                            <small>From: {{ formatToMbps(order.selectedQuote.productSpeed.estimatedDownloadRange) }} to</small>
                            <h3 class="text-ukit-primary">{{ formatToMbps(order.selectedQuote.productSpeed.estimatedDownloadRange) }}</h3>
                          </span>
                        </div>
                        <div class="col-md-6">
                          <strong>Upload</strong><br>
                          <span v-if="order.selectedQuote.productSpeed.estimatedUploadRange.includes('-')">
                            <small>From: {{ formatHyphenatedMinToMbps(order.selectedQuote.productSpeed.estimatedUploadRange) }} to</small>
                            <h3 class="text-ukit-primary">{{ formatHyphenatedMaxToMbps(order.selectedQuote.productSpeed.estimatedUploadRange) }}</h3>
                          </span>
                          <span v-if="!order.selectedQuote.productSpeed.estimatedUploadRange.includes('-')">
                            <small>From: {{ formatToMbps(order.selectedQuote.productSpeed.estimatedUploadRange) }} to</small>
                            <h3 class="text-ukit-primary">{{ formatToMbps(order.selectedQuote.productSpeed.estimatedUploadRange) }}</h3>
                          </span>
                        </div>
                        <button v-on:click="startAgain()" class="btn btn-ukit-secondary btn-block mr-4 ml-4">Start Again</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="bbc_promoContainer">
                <zoom-center-transition>
                  <div v-if="stage === 'showDeals'" class="results" style="width:100%; height:100%; padding: 15px;">
                    <div class="float-right">
                      <div class="form-check float-left mr-2">
                        <input v-model="quoteFilter.includeADSL" type="checkbox" class="form-check-input" id="exampleCheck1">
                        <label class="form-check-label" style="font-size: 12px;">Include ADSL</label>
                      </div>
                      <div class="form-check float-left mr-2">
                        <input v-model="quoteFilter.includeSOGEA" type="checkbox" class="form-check-input" id="exampleCheck1">
                        <label class="form-check-label" style="font-size: 12px;">Include SOGEA</label>
                      </div>
                      <div class="form-check float-left">
                        <input v-model="quoteFilter.includeFTTC" type="checkbox" class="form-check-input" id="exampleCheck1">
                        <label class="form-check-label" style="font-size: 12px;" >Include FTTC</label>
                      </div>
                    </div>
                    <h3 style="text-align: left;">Broadband Results<button v-on:click="toggleSpeedTest()" class="btn btn-xs btn-ukit-primary ml-3">Test Your Current Connection</button></h3>
                    <div class="row">
                      <table class="table table-striped table-hover">
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th class="text-center">Download Speeds</th>
                            <th class="text-center">Upload Speeds</th>
                            <th class="text-center">Minimum Speed</th>
                            <th class="text-center">Price</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(quote,index) in filteredQuotes" v-bind:key="quote.productId">
                            <td class="productTblName text-ukit-secondary">
                              <span v-if="index != 0">
                                {{ quote.productName }}<v-icon style="margin: -2px 2px 0px 5px;" color="green darken-2" v-on:click="toggleSOGEAInfo()" v-if="quote.productName.includes('SOGEA')">info</v-icon>
                              </span>
                              <span v-if="index === 0">
                                <div class="float-left mr-2">
                                  {{ quote.productName }}<v-icon style="margin: -2px 2px 0px 5px;" color="green darken-2" v-on:click="toggleSOGEAInfo()" v-if="quote.productName.includes('SOGEA')">info</v-icon>
                                </div>
                                <div style="background-color: #042b56;border-radius: 20px;height: 26px;float: right;padding: 0px 10px 0px 10px; width: 91px;">
                                  <i class="fa fa-tachometer text-white mr-1" style="padding: 0px;pading-top: 0px;margin-top: 0px;font: normal normal normal px/1 FontAwesome;"></i><span class="text-ukit-primary" style="font-weight: 600;">Fastest</span>
                                </div>
                              </span>
                              <!-- <div class=""><i class="fa fa-tachometer mr-1"></i> <span class="text-ukit-primary">Fastest</span></div> -->
                            </td>
                            <td style="font-size:small; padding:5px;" class="text-center">
                              <!-- <div class="block">From: 12.4Mbps</div>
                              <div class="block">To: 18.6Mbps</div> -->
                              <span v-if="quote.productSpeed.estimatedDownloadRange.includes('-')">{{ formatHyphenatedToMbps(quote.productSpeed.estimatedDownloadRange) }}</span>
                              <span v-if="!quote.productSpeed.estimatedDownloadRange.includes('-')">{{ formatToMbps(quote.productSpeed.estimatedDownloadRange) }}</span>
                            </td>
                            <td style="font-size:small; padding:5px;" class="text-center">
                              <span v-if="quote.productSpeed.estimatedUploadRange.includes('-')">{{ formatHyphenatedToMbps(quote.productSpeed.estimatedUploadRange) }}</span>
                              <span  v-if="!quote.productSpeed.estimatedUploadRange.includes('-')">{{ formatToMbps(quote.productSpeed.estimatedUploadRange) }}</span>
                            </td>
                            <td style="font-size:small;" class="text-center text-ukit-primary">{{ formatToMbps(quote.productSpeed.minimumGuaranteedSpeed) }}</td>
                            <td style=" padding:5px;">
                              <div>
                                £{{ toTwoDecimalPlaces(quote.pricing.broadbandMonthlyRental) }}<span style="font-size:small;">/Month</span>
                              </div>
                              <div style="font-size:small;">
                                <span v-if="order.orderType !== 'Existing Line'">£{{ toTwoDecimalPlaces(quote.pricing.broadbandConnectionCost) }} connection</span>
                                <span v-if="order.orderType === 'Existing Line'">£{{ toTwoDecimalPlaces(quote.pricing.migrationSellRate) }} migration</span>
                              </div>
                            </td>
                            <td class="text-center">
                              <button v-on:click="selectBroadband(quote)" class="btn btn-ukit-primary btn-sm btn-block ">Select Broadband</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </zoom-center-transition>

                <div v-if="stage === 'fetchingDeals'" class="results" style="height:300px;">
                  <span></span>
                </div>

                <zoom-center-transition>
                  <div v-if="stage === 'prequoteQuestions'"  class="results">
                    <v-form ref="prequoteQuestionsForm" lazy-validation v-model="prequoteQuestionsFormValid" class="bbc_zeroTop">
                      <v-container class="">
                        <v-row class="">
                          <v-col class="" cols="12" md="12">
                            <div>
                              <div v-if="showAssistant === true" class="row">
                                <div class="col-md-8 offset-md-2">
                                  <div class="card">
                                    <div class="card-body text-center greenBorderski">
                                      <h4 class="mb-3">Bearer Speed / Data Rate Calculator</h4>
                                      <a-input-number class="mr-2" id="inputNumber" v-model="calculator.userNumber" :min="1" @change="calculatorUserNumberChange" /> <span style="color: #310130; font-size: 1.25rem; margin-bottom: .5rem; font-weight: 500; line-height: 1.2;">Number of Users</span>
                                      <a-select class="mt-4" @change="calculatorUsageTypeChange" size="large" default-value="Please Select a Usage Type"  v-model="calculator.usageType">
                                        <a-select-option v-for="usageType in usageTypes" v-bind:key="usageType.value" :value="usageType.value">{{ usageType.text }}</a-select-option>
                                      </a-select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <h5>Ethernet Bearer</h5>
                              <v-row>
                                <v-col cols="12">
                                  <a-select @change="ethernetBearerSpeedChanged" size="large" default-value="Please Select"  v-model="searchData.bearer">
                                    <a-select-option v-for="speed in ethernetBearerSpeeds" v-bind:key="speed.value" :value="speed.value">{{ speed.text }}</a-select-option>
                                  </a-select>
                                </v-col>
                              </v-row>
                              <h5>Ethernet Speed</h5>
                              <v-row>
                                <v-col cols="12">
                                  <a-select :disabled="!searchData.bearer" @change="ethernetRateChanged" size="large" default-value="Please Select"  v-model="searchData.linecdr">
                                    <a-select-option v-for="rate in ethernetRates" v-bind:key="rate.value" :value="rate.value">{{ rate.text }}</a-select-option>
                                  </a-select>
                                </v-col>
                              </v-row>
                              <h5>Business Email Address</h5>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field required :rules="emailRules"  filled dense v-model="order.emailAddress" label="Business Email Address" ></v-text-field>
                                </v-col>
                              </v-row>
                              <a-button v-if="prequoteQuestionsFormValid && searchData.bearer && order.emailAddress && searchData.linecdr" @click="finishPreQuoteDetails" class="btn-block btn-ukit-primary" size="large">Get Quotes</a-button>
                              <a-button v-if="!prequoteQuestionsFormValid || !searchData.bearer || !order.emailAddress || !searchData.linecdr" disabled class="disabled btn-block btn-ukit-primary" size="large">Get Quotes</a-button>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </div>
                </zoom-center-transition>

                <zoom-center-transition>
                  <div v-if="stage === 'pickAddress' || stage === 'addressSearch'" class="bbc_promobg">
                    <div class="addressSlideIn">
                      <zoom-center-transition>
                        <div v-if="stage === 'pickAddress'" class="bbc_addressList">
                          <div v-on:click="backToSearch()" class="text-white backbtn" >Back >></div>
                          <table class="table table-striped table-hover" style="cursor:pointer">
                            <tbody>
                              <tr v-on:click="selectAddress(address, index)" :key="address.index" v-for="address in addresses">
                                <td style="text-align: left;">{{ parseAddress(address) }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </zoom-center-transition>
                      <zoom-center-transition>
                        <div v-if="stage === 'addressSearch'" class="bbc_addressSearch" :class="{bbc_expanded : stage === 'pickPostCode'}">
                          <div>
                            <a-form :form="addressSearchForm">
                              <a-row>
                                <a-col class="pr-3 pl-3" :sm="12" :md="16">
                                  <a-form-item>
                                    <template slot="label">
                                      <i class="fa fa-home text-ukit-primary mr-1"></i> <span style="font-size: 17px;color: #042B56;">Post Code</span>
                                    </template>
                                    <a-input v-decorator="['note', { rules: [{ required: true, message: 'Please enter a post code!' }] }]" v-model="postcode" size="large"/>
                                  </a-form-item>
                                </a-col>
                                <a-col class="pr-3 pl-3"  :sm="12" :md="8">
                                  <a-button  @click="search" class="btn-block btn-ukit-secondary" style="margin-top: 47px;" size="large" type="primary" html-type="submit">Search</a-button>
                                </a-col>
                              </a-row>
                            </a-form>
                          </div>
                        </div>
                      </zoom-center-transition>
                    </div>
                  </div>
                </zoom-center-transition>
              </div>
            </div>

            <a-modal :footer="null" v-model="showSoegeaInfo" title="SOGEA Explained" ok-text="OK" @ok="showSoegeaInfo = false">
              SOGEA <small>(Single Order Generic Etherner Access)</small> is a single order variant, meaning that there is no traditional landline.
              The result of this is that a you cannot make calls via this line unless you use an internet based solution such as VoIP phone system.
              <br>
              <br />
              <div style="margin-top:-20px;" class="float-right">
                <button class="btn btn-sm btn-ukit-primary" v-on:click="toggleSOGEAInfo()">OK</button>
              </div>
            </a-modal>
            <a-modal :width="650"  :footer="null" v-model="showSpeedTest" title="Broadband Speed Test" ok-text="OK" @ok="showSoegeaInfo = false">
              <iframe frameBorder="0" src="https://openspeedtest.com/Get-widget.php" width="600" height="350" style="display:block; margin:auto;"></iframe>
              <br>
              <br />
              <div style="margin-top:-20px;" class="float-right">
                <button class="btn btn-sm btn-ukit-primary" v-on:click="toggleSpeedTest()">CLOSE</button>
              </div>
            </a-modal>
          </div>
          <!-- <div class="row">
            <div clas="col-md-12 text-center mt-4"></div>
          </div> -->
          <div class="row">
            <div class="col-md-12 pt-0  text-center">
              <a target="_blank" href="http://www.ravenware.co.uk"><img src="resources/poweredByRavenware.png" alt="Powered by Ravenware ltd"></a>
            </div>
          </div>
        </div>

        <div id="carousel-wrap">
          <carousel :items="7" :margin="100" :loop="true" :nav="false" :autoplay="true" :autoplaySpeed="3000">
            <img src="resources/images/logos/bt-wholesale.png">
            <img src="resources/images/logos/virgin-media.png">
            <img src="resources/images/logos/cisco.png">
            <img src="resources/images/logos/cityfibre.png">
            <img src="resources/images/logos/openreach.png">
            <img src="resources/images/logos/talktalk-business.png">
            <img src="resources/images/logos/colt.png">
            <img src="resources/images/logos/vodafone.png">
            <img src="resources/images/logos/virtual1.png">
            <img src="resources/images/logos/sse.png">
          </carousel>
        </div>

        <div class="deals-wrap">
          <div class="row">
            <div class="col-4">
              <div class="deal">
                <div class="deal-top">
                  <h6>Lowest Cost</h6>
                  <p class="deal-product">100Mb Managed Ethernet</p>
                  <p class="deal-price">From <strong>£199.00</strong> per month</p>
                  <a href="#greenFrame" class="btn btn-white">Check availability</a>
                </div>
                <div class="deal-bottom">
                  <p><i class="fa fa-check"></i> Free Installation*</p>
                  <p><i class="fa fa-check"></i> 6 Hour Fix Time SLA</p>
                  <p><i class="fa fa-check"></i> 12, 36 or 60 Month Contract</p>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="deal focus">
                <div class="deal-top">
                  <h6>Most Popular</h6>
                  <p class="deal-product">500Mb Managed Ethernet</p>
                  <p class="deal-price">From <strong>£299.00</strong> per month</p>
                  <a href="#greenFrame" class="btn btn-white">Check availability</a>
                </div>
                <div class="deal-bottom">
                  <p><i class="fa fa-check"></i> Free Installation*</p>
                  <p><i class="fa fa-check"></i> 6 Hour Fix Time SLA</p>
                  <p><i class="fa fa-check"></i> 12, 36 or 60 Month Contract</p>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="deal">
                <div class="deal-top">
                  <h6>Best Value</h6>
                  <p class="deal-product">1Gb Managed Ethernet</p>
                  <p class="deal-price">From <strong>£399.00</strong> per month</p>
                  <a href="#greenFrame" class="btn btn-white">Check availability</a>
                </div>
                <div class="deal-bottom">
                  <p><i class="fa fa-check"></i> Free Installation*</p>
                  <p><i class="fa fa-check"></i> 6 Hour Fix Time SLA</p>
                  <p><i class="fa fa-check"></i> 12, 36 or 60 Month Contract</p>
                </div>
              </div>
            </div>
            <small>*subject to a 36 month contract</small>
          </div>
        </div>

        <div class="faqs-wrap">
          <div class="row">
            <div class="col-3 faq-questions">
              <h4>Frequently Asked Questions</h4>
              <div class="questions">
                <div v-for="(faq,index) in faqs" v-bind:key="index" class="faq-question" v-on:click="selectFaq(index)">
                  <h6 v-if="selectedFaq == index" class="selected"><i class="fa fa-question-circle"></i> {{ faq.question }}</h6>
                  <h6 v-else><i class="fa fa-question-circle"></i> {{ faq.question }}</h6>
                </div>
              </div>
            </div>
            <div class="col-9 faq-answers">
              <div class="answers">
                <div v-for="(faq,index) in faqs" v-bind:key="index" class="faq-answer">
                  <div v-if="selectedFaq == index" class="answer-wrap">
                    <div class="answer">
                      <h5>{{ faq.question }}</h5>
                      <p>{{ faq.answer }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <a href="/support" class="btn btn-ukit-secondary">Contact Us</a>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div id="footer-top">
      <h6>Need some assistance? We can help.</h6>
      <v-btn href="/about-us">Find out more</v-btn>
    </div>

    <div id="footer-bottom">
      <div class="row">
        <div class="col-md-3">
          <img class="footer-logo" src="resources/images/logos/uk_business_broadband_x300.png" alt="UK Business Broadband Logo">
        </div>
        <div class="col-md-9">
          <ul class="footer-menu">
            <li><a href="https://ukitnetworks.com/privacy-policy/" target="_blank" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2479">Privacy Policy v1.0</a></li>
            <li><a href="/support" class="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-2542 current_page_item menu-item-2699">Customer Support</a></li>
            <li><a href="https://ukitnetworks.com/terms-and-conditions/" target="_blank" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-2478">Terms and Conditions</a></li>
          </ul>
          <div class="legal-details">
            <p>Registered in England and Wales: 8026657</p>
            <p>Ofcom Reseller ID: FLV</p>
            <p>ICO Reg Number: A422750</p>
            <p>VAT Reg Number: 121 9534 29</p>
          </div>
        </div>
        <div class="col-md-12">
          <div class="social-icons">
            <a href="https://www.linkedin.com/company/uk-it-networks-limited"><i class="fa fa-linkedin-square"></i></a>
            <a href="https://twitter.com/ukitnetworks?lang=en"><i class="fa fa-twitter-square"></i></a>
            <a href="https://www.facebook.com/UKITNET/"><i class="fa fa-facebook-square"></i></a>
          </div>
          <div class="contact-icons">
            <a href="tel:03443262154"><i class="fa fa-phone-square"></i></a>
            <a href="mailto:info@ukbusinessbroadband.com" target="_blank"><i class="fa fa-envelope-square"></i></a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import _ from 'lodash'
import { ZoomCenterTransition } from 'vue2-transitions'
import termsandconditions from '@/components/tenant/ukittermsandconditions'
import carousel from 'vue-owl-carousel'

export default {
  name: 'Home',
  components: {
    Loading,
    ZoomCenterTransition,
    termsandconditions,
    carousel,
  },

  mounted() {
    this.mounted = true
    this.iframeHeightChangeNotifyParent()
    this.getBrowserUsed()
  },

  computed: {
    filteredQuotes: function() {
      let retARR = this.quotes.filter(q => this.displayQuote(q)).sort((b, a) => a.productSpeed.minimumGuaranteedSpeed - b.productSpeed.minimumGuaranteedSpeed)
      return retARR
    },
  },

  created() {
    window.addEventListener('resize', this.windowResized)

    if (this.$route.query.tid) {
      this.searchData.tid = this.$route.query.tid
      this.getTenantTheme(this.$route.query.tid)
    } else {
      this.searchData.tid = '2807F490-5E8A-46BE-9718-0172CCB13B4F'
    }
  },

  watch: {
  },

  methods: {
    getTenantTheme(tid) {
      this.$http.get('/api/Tenant/getTenantTheme/' + tid)
        .then(response => {
          this.clientTheme = response.data
        }
        )
        .catch(e => {
          this.errors.push(e)
        })
    },

    setCalcValues() {
      if (this.calculator.usageType != null && this.calculator.userNumber != null) {
        let o = this.calculator.usageType // low,medium,high
        let n = this.calculator.userNumber // user number
        let r = null

        switch (o) {
          case 2: // "low":
            r = n <= 41 ? 10 : n <= 81 ? 20 : n <= 117 ? 30 : n <= 161 ? 40 : n <= 201 ? 50 : n <= 397 ? 100 : n <= 500 ? 200 : 300
            break
          case 3: // "medium":
            r = n <= 18 ? 10 : n <= 40 ? 20 : n <= 60 ? 30 : n <= 80 ? 40 : n <= 98 ? 50 : n <= 120 ? 60 : n <= 198 ? 100 : n <= 400 ? 200 : n <= 500 ? 300 : 500
            break
          case 4: // 'high":
            r = n <= 9 ? 10 : n <= 20 ? 20 : n <= 30 ? 30 : n <= 39 ? 40 : n <= 50 ? 50 : n <= 60 ? 60 : n <= 99 ? 100 : n <= 200 ? 200 : n <= 300 ? 300 : n <= 400 ? 400 : n <= 500 ? 500 : 1e3
        }
        // set bearer and CDR based on R
        if (r <= 100) {
          this.ethernetBearerSpeedChanged(100)
          this.searchData.bearer = 100
          this.searchData.linecdr = r.toString()
        } else {
          this.ethernetBearerSpeedChanged(1000)
          this.searchData.bearer = 1000
          this.searchData.linecdr = r.toString()
        }
      }
      // if (this.calculator.usageType === 2) { // low
      //   if (r <= 100) {
      //     this.searchData.bearer = 100
      //     this.searchData.linecdr = r
      //   } else { // set bearer to 100 and cdr to r
      //     this.searchData.bearer = 1000
      //     this.searchData.linecdr = r
      //   }
      // } else if (this.calculator.usageType === 3) { // medium

      // } else if (this.calculator.usageType === 3) { // high
      //   alert('ffs')
      // }
      this.iframeHeightChangeNotifyParent()
    },

    calculatorUserNumberChange(e) {
      this.calculator.userNumber = e
      this.setCalcValues()
    },

    calculatorUsageTypeChange() {
      this.setCalcValues()
    },

    ethernetBearerSpeedChanged(e) {
      if (e === 100) {
        this.ethernetRates = this.ethernetRateSets[0].values
      } else if (e === 1000) {
        this.ethernetRates = this.ethernetRateSets[1].values
      } else {
        this.showAssistant = true
        this.ethernetRates = [{ text: 'Please Select A Bearer', value: 'Please Select A Bearer' }]
      }
      this.$nextTick(function() {
        this.iframeHeightChangeNotifyParent()
      })
    },

    ethernetRateChanged(e) {
    },

    toggleSpeedTest() {
      if (this.showSpeedTest) {
        this.showSpeedTest = false
      } else {
        this.showSpeedTest = true
      }
    },

    getBrowserUsed() {
      this.order.browserUsed = 'xx'
    },

    toggleLoading() {
      if (this.isLoading === true) {
        this.isLoading = false
      } else {
        this.isLoading = true
      }
    },

    termChanged() {
      this.calcTotals()
    },

    calcTotals() {
      this.order.totalOneOffCost = parseFloat(this.toTwoDecimalPlaces(this.order.routerCost)) + parseFloat(this.toTwoDecimalPlaces(this.order.selectedQuote.pricing.broadbandConnectionCost))
      this.order.totalMonthlyCost = parseFloat(this.toTwoDecimalPlaces(this.order.selectedQuote.pricing.broadbandMonthlyRental)) + parseFloat(this.toTwoDecimalPlaces(this.order.selectedQuote.pricing.businessLineRentalCost))
    },

    routerChanged(val) {
      if (val === 'Technicolor Wired') {
        this.order.routerCost = 47.80
      } else if (val === 'Technicolor Wireless') {
        this.order.routerCost = 72.59
      } else {
        this.order.routerCost = 0.00
      }

      this.calcTotals()
    },

    handleScroll: function(el) {
      if ((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
        this.hasScrolledToBottom = true
      }
    },

    lineTypeChange(value) {
      // reset form.
      this.addressSearchForm.resetFields()
      if (value === 'New Line') {
        this.order.newLineRequired = true
      } else {
        this.order.newLineRequired = false
      }

      this.calcTotals()
    },

    toTwoDecimalPlaces: function(value) {
      if (value === null) {
        return 0.00
      } else {
        return parseFloat(value).toFixed(2)
      }
    },

    windowResized: _.debounce(function(e) {
      let width = document.getElementById('ravenwareSite').scrollWidth
      if (width !== this.windowSize.width) {
        this.windowSize.width = document.getElementById('ravenwareSite').scrollWidth
        this.iframeHeightChangeNotifyParent()
      }
    }, 1),

    iframeHeightChangeNotifyParent: _.debounce(function(e) {
      let height
      let el = document.getElementById('ravenwareSite')
      if (el != null) {
        height = document.getElementById('ravenwareSite').scrollHeight
      } else {
        height = 200
      }
      window.parent.postMessage({ frameHeight: height }, '*')
    }, 1),

    iframeHeightSpecificSizeNotifyParent(height) {
      window.parent.postMessage({ frameHeight: height }, '*')
    },

    toggleSOGEAInfo() {
      if (this.showSoegeaInfo === true) {
        this.showSoegeaInfo = false
      } else {
        this.showSoegeaInfo = true
      }
    },

    displayQuote(quote) {
      let display = true
      if (quote.productName.includes('SOGEA') && this.quoteFilter.includeSOGEA === false) {
        display = false
      }
      if (quote.productName.includes('ADSL') && this.quoteFilter.includeADSL === false) {
        display = false
      }
      if ((quote.productName.includes('FTTC') && !quote.productName.includes('SOGEA')) && this.quoteFilter.includeFTTC === false) {
        display = false
      }
      return display
    },

    //   test() {
    //     this.$http.get('https://api.ideal-postcodes.co.uk/v1/postcodes/' + this.postcode)
    //     .then(response => {
    //         this.testxx  = response.data
    //     this.posts = response.data
    //     })
    //     .catch(e => {
    //     this.errors.push(e)
    //     })
    //   },

    startAgain() {
      this.stage = 'addressSearch'
      this.iframeHeightChangeNotifyParent()
    },

    scrollToTop() {
      var el = this.$el.getElementsByClassName('scrolltop')[0]

      if (el) {
        el.scrollIntoView()
      }
    },

    parseAddress(address) {
      return [address.subPremesis, address.building, address.street, address.locality, address.city, address.county, address.postcode].filter(Boolean).join(' ')
    },

    copyAuthDetailsToAccount() {
      this.order.accountsContactName = this.order.authorisedContactName
      this.order.accountsContactEmail = this.order.emailAddress
    },

    addressChange() {
      if (this.order.billingAddressSameAsInstall) {
        this.order.addresses[1].address = this.order.addresses[0].address
        this.order.addresses[1].street = this.order.addresses[0].street
        this.order.addresses[1].county = this.order.addresses[0].county
        //  this.order.addresses[1].country = this.order.addresses[0].country
        this.order.addresses[1].postcode = this.order.addresses[0].postcode
      }
    },

    toggleSameBillingAddress() {
      if (!this.order.billingAddressSameAsInstall) {
        // this.order.billingAddressSameAsInstall = false
        this.order.addresses[1].address = null
        this.order.addresses[1].street = null
        this.order.addresses[1].county = null
        // this.order.addresses[1].country = null
        this.order.addresses[1].postcode = null
      } else {
        // this.order.billingAddressSameAsInstall = true
        this.order.addresses[1].address = this.order.addresses[0].address
        this.order.addresses[1].street = this.order.addresses[0].street
        this.order.addresses[1].county = this.order.addresses[0].county
        //  this.order.addresses[1].country = this.order.addresses[0].country
        this.order.addresses[1].postcode = this.order.addresses[0].postcode
      }
    },

    toggleExistingCustomer() {
      if (this.order.existingCustomer) {
        this.order.existingCustomer = false
        this.order.companyType = 'New Customer'
      } else {
        this.order.existingCustomer = true
        this.order.companyType = 'Existing Customer'
      }
      this.calcTotals()
    },

    completeOrder() {
      // let loader = this.$loading.show({ container: this.$refs.greenFrame ? null : this.$refs.formContainer, onCancel: this.onCancel, color: '#B9D253' })
      this.toggleLoading()
      // this.order.search = this.search
      this.$http.post('/api/broadband/raiseOrder/', this.order)
        .then(response => {
          this.toggleLoading()
          // loader.hide()
          this.stage = 'thankyou'
          this.scrollToTop()
          this.iframeHeightChangeNotifyParent()
        }
        )
        .catch(e => {
          this.errors.push(e)
        })
    },

    nextStep() {
      this.currentStep += 1
      this.scrollToTop()
    },

    gotToAgreement() {
      if (this.$refs.installForm.validate()) {
        this.currentStep = 4
        this.scrollToTop()
      }
    },

    goToInstall() {
      if (this.$refs.detailsForm.validate()) {
        this.currentStep = 2
        this.scrollToTop()
      }
    },

    previousStep() {
      this.currentStep -= 1
      this.scrollToTop()
    },
    getAddressMatches() {
      // this.$nextTick(function() {
      //   this.iframeHeightChangeNotifyParent()
      // })
      this.toggleLoading()
      // let loader = this.$loading.show({ container: this.$refs.greenFrame ? null : this.$refs.formContainer, onCancel: this.onCancel, color: '#B9D253' })
      let address = { postcode: this.postcode, paramCarrier: { tid: this.searchData.tid } }
      this.$http.post('/api/broadband/addressLookup/', address)
        .then(response => {
          this.toggleLoading() // loader.hide()
          this.addresses = response.data
          this.iframeHeightChangeNotifyParent()
        })
        .catch(e => {
          this.errors.push(e)
        })

      // this.$http.get('https://api.ideal-postcodes.co.uk/v1/postcodes/' + this.postcode, {headers: { 'Authorization': 'IDEALPOSTCODES api_key="xxxx"' }})
      // .then(response => {
      //     this.addresses = response.data.result
      // })
      // .catch(e => {
      // this.errors.push(e)
      // })
    },

    search(e) {
      e.preventDefault()
      this.addressSearchForm.validateFields((err, values) => {
        if (!err) { // check form for missing fields.
          this.stage = 'pickAddress'
          this.iframeHeightChangeNotifyParent()
          this.$nextTick(function() {
            this.getAddressMatches()
          })
        }
      })
    },

    searchMigration(e) {
      e.preventDefault()
      this.addressSearchForm.validateFields((err, values) => {
        if (!err) { // check form for missing fields.
          this.stage = 'fetchingDeals'
          this.iframeHeightChangeNotifyParent()
          let address = { cli: this.landline }
          this.getQuotes(address)
        }
      })
    },

    backToSearch() {
      this.stage = 'addressSearch'
      this.iframeHeightChangeNotifyParent()
    },

    selectAddress(address) {
      this.stage = 'prequoteQuestions'
      this.iframeHeightSpecificSizeNotifyParent(479)
      this.searchData.selectedAddress = address

      // set search criteria.
      this.searchData.postcode = address.postcode
      this.searchData.addressLineOne = [address.subPremesis, address.building].filter(Boolean).join(' ')
      this.searchData.addressLineTwo = address.street
      this.searchData.addressLineThree = address.county
      this.searchData.post_town = address.city
      this.searchData.premises = [address.subPremesis, address.building, address.street, address.city, address.county].filter(Boolean).join(' ')
      this.searchData.locality = address.locality
      this.searchData.addressReference = address.addressReference
      this.searchData.cssDatabaseCode = address.cssDatabaseCode
      // set install address
      this.order.addresses[0].address = [address.subPremesis, address.building].filter(Boolean).join(' ')
      this.order.addresses[0].street = address.street
      this.order.addresses[0].county = address.county

      // this.order.addresses[0].country = address.country
      this.order.addresses[0].postcode = address.postcode
      // set billing address
      this.order.addresses[1].address = [address.subPremesis, address.building].filter(Boolean).join(' ')
      this.order.addresses[1].street = address.street
      this.order.addresses[1].county = address.county
      // this.order.addresses[1].country = address.country
      this.order.addresses[1].postcode = address.postcode
    },

    finishPreQuoteDetails(e) {
      e.preventDefault()
      this.prequoteQuestionsForm.validateFields((err, values) => {
        if (!err) { // check form for missing fields.
          this.getQuoteResults()
        }
      })
    },

    getQuoteResults() {
      // let loader = this.$loading.show({ container: this.$refs.greenFrame, onCancel: this.onCancel, color: '#B9D253' })
      // this.search.tid = this.params.tid
      // this.search.

      this.toggleLoading()
      this.$http.post('/api/ethernet/quotesLookup/', this.searchData)
        .then(response => {
          this.toggleLoading()
          this.$router.push({ name: 'EthernetResults', query: { id: response.data.id } })
        })
        .catch(e => {
          this.toggleLoading()
          this.$message.error('There has been an error returning the enquiry form please try again.')
        })
    },

    selectBroadband(quote) {
      this.order.selectedQuote = quote
      this.stage = 'order'
      this.setFormattedValues(quote)
      this.calcTotals()
      this.$nextTick(function() {
        this.iframeHeightChangeNotifyParent()
        this.scrollToTop()
      })
    },

    setFormattedValues(quote) {
      // format download
      if (quote.productSpeed.estimatedDownloadRange.includes('-')) {
        quote.productSpeed.formattedEstimatedDownloadRange = this.formatHyphenatedToMbps(quote.productSpeed.estimatedDownloadRange)
      } else {
        quote.productSpeed.formattedEstimatedDownloadRange = this.formatToMbps(quote.productSpeed.estimatedDownloadRange)
      }
      // format upload
      if (quote.productSpeed.estimatedUploadRange.includes('-')) {
        quote.productSpeed.formattedEstimatedUploadRange = this.formatHyphenatedToMbps(quote.productSpeed.estimatedUploadRange)
      } else {
        quote.productSpeed.formattedEstimatedUploadRange = this.formatToMbps(quote.productSpeed.estimatedUploadRange)
      }
      // format upload
      quote.productSpeed.formattedMinimumGuaranteedSpeed = this.formatToMbps(quote.productSpeed.minimumGuaranteedSpeed)
    },

    formatHyphenatedToMbps(value) {
      let arr = value.split(' - ')
      if (arr[0] <= 0) { arr[0] = 0 }
      if (arr[1] <= 0) { arr[0] = 0 }
      let ret = (arr[1] / 1000).toFixed(2) + 'Mbps - ' + (arr[0] / 1000).toFixed(2) + 'Mbps'
      return ret
    },

    formatHyphenatedMinToMbps(value) {
      let arr = value.split(' - ')
      if (arr[0] <= 0) { arr[0] = 0 }
      if (arr[1] <= 0) { arr[0] = 0 }
      let ret = (arr[0] / 1000).toFixed(2) + 'Mbps'
      return ret
    },

    formatHyphenatedMaxToMbps(value) {
      let arr = value.split(' - ')
      if (arr[0] <= 0) { arr[0] = 0 }
      if (arr[1] <= 0) { arr[0] = 0 }
      let ret = (arr[1] / 1000).toFixed(2) + 'Mbps'
      return ret
    },

    formatToMbps(value) {
      if (value <= 0) { value = 0 }
      return (value / 1000).toFixed(2) + 'Mbps'
    },

    selectFaq(index) {
      this.selectedFaq = index
    },
  },

  beforeCreate() {
    this.addressSearchForm = this.$form.createForm(this, { name: 'addressSearch' })
    this.prequoteQuestionsForm = this.$form.createForm(this, { name: 'prequoteQuestionsForm' })
  },

  data: () => ({
    clientTheme: { primaryColor: '#0F2D59', secondaryColor: '#AFCB3A' },
    usageTypes: [{ value: 1, text: 'Please Select a Usage Type' }, { value: 2, text: 'Low - Email and simple Web Surfing' }, { value: 3, text: 'Medium - Web Applications and Streaming Audio' }, { value: 4, text: 'High - Large file transfers, multiple server applications, voice and data' }],
    showAssistant: false,
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid',
    ],
    calculator: { usageType: 1, userNumber: 0 },
    searchData: {
      tid: null,
      id: null,
      postcode: null,
      addressLineOne: null,
      addressLineTwo: null,
      addressLineThree: null,
      post_town: null,
      premises: null,
      type: null,
      bearer: null,
      linecdr: null,
      email: null,
      source: null,
      selectedAddress: null,
      ethernetBearerSpeeed: '',
      ethernetRate: '',
    },
    ethernetTypes: [],
    ethernetBearerSpeeds: [{ text: 'Don\'t Know', value: 0 }, { text: '100Mb', value: 100 }, { text: '1Gb', value: 1000 }],
    ethernetRates: ['Please Select A Bearer'],
    ethernetRateSets: [{ id: '100Mb', values: [{ text: '10Mb', value: '10' }, { text: '20Mb', value: '20' }, { text: '30Mb', value: '30' }, { text: '40Mb', value: '40' }, { text: '50Mb', value: '50' }, { text: '60Mb', value: '60' }, { text: '70Mb', value: '70' }, { text: '80Mb', value: '80' }, { text: '90Mb', value: '90' }, { text: '100Mb', value: '100' }] }, { id: '1Gb', values: [{ text: '100Mb', value: '100' }, { text: '200Mb', value: '200' }, { text: '300Mb', value: '300' }, { text: '400Mb', value: '400' }, { text: '500Mb', value: '500' }, { text: '600Mb', value: '600' }, { text: '700Mb', value: '700' }, { text: '800Mb', value: '800' }, { text: '900Mb', value: '900' }, { text: '1Gb', value: '1000' }] }],
    windowSize: { width: 0 },
    requiredShort: [
      v => !!v || 'required',
    ],
    requiredRules: [
      v => !!v || 'This field is required',
    ],
    prequoteQuestionsFormValid: true,
    installFormValid: true,
    detailsFormValid: true,
    showSpeedTest: false,
    browserUsed: 'unknown',
    isLoading: false,
    hasScrolledToBottom: false,
    loadski: true,
    mounted: false,
    API_URL: null,
    showSoegeaInfo: false,
    quoteFilter: { includeSOGEA: true, includeADSL: true, includeFTTC: true },
    orderTypes: ['New Line', 'Migration'],
    quotes: null,
    testxx: null,
    sortcode1: null,
    sortcode2: null,
    sortcode3: null,
    differentBillingDetails: false,
    order: {
      // old below.
      companyType: 'New Customer',
      totalOneOffCost: 0.00,
      totalMonthlyCost: 0.00,
      routerCost: 0.00,
      router: 'No Router Required',
      //   newLineRequired: true,
      termLength: '36 Months',
      orderType: 'New Line',
      accountNumber: null,
      sortcode: null,
      customerNumber: null,
      existingCustomer: false,
      selectedQuote: null,
      billingAddressSameAsInstall: true,
      companyName: null,
      emailAddress: null,
      accountSite: null,
      phoneNumber: null,
      faxNumber: null,
      website: null,
      numberOfEmployees: null,
      registeredNumber: null,
      billingMethod: null,
      authorisedContactName: null,
      authorisedContactEmail: null,
      authorisationAccess: null,
      accountsContactName: null,
      accountsContactEmail: null,
      accountsContactTelephone: null,
      addresses: [
        { type: 'install', address: null, street: null, county: null, country: 'United Kindgom', postcode: null },
        { type: 'billing', address: null, street: null, county: null, country: 'United Kindgom', postcode: null },
      ],
    },
    currentStep: 1,
    showLoading: true,
    addresses: [],
    postcode: null,
    landline: '',
    rules: [
      value => !!value || 'Required.',
      value => (value && value.length >= 3) || 'Min 3 characters',
    ],
    // stages addressSearch , pickAddress
    // searchData: { postcode: null, landLine: null },
    stage: 'addressSearch',
    isValid: false,
    faqs: [
      { question: 'Which Networks do you partner with for Ethernet Leased Lines?', answer: 'We have multiple partnering agreements for our Ethernet Leased Line agreements. Utilising a close relationship with BT, Vodafone, TTB and Virgin we can ensure that we can obtain the most competitive pricing for your Ethernet Leased Line quotation.' },
      { question: 'What support can I expect from having an Internet Leased Line?', answer: 'We don’t operate multiple queues. We provide each and every customer a dedicated account manager. So if you ever encounter an issue or query with your Internet Leased line, one call to your account manager or our dedicated support team is all it takes to find resolution.' },
      { question: 'What Service Level Agreement can I expect from an Internet Leased Line?', answer: 'As standard, Internet Leased Lines are highly resilient. We offer a 99.985% protected circuit availability SLA. We are aware some ISP’s provide a 100% SLA, however you’d probably find that all service credits will work out similar should you ever encounter an outage.' },
      { question: 'What options are there for backup on Ethernet Leased Lines?', answer: 'We offer all of our customers failover connectivity for their Ethernet Leased Line ranging from ADSL2+, FTTC to an alternative carrier’s Ethernet. Using Cisco technology our failover is provided using HSRP. If we provided one Internet Leased Line over one BTW and the other over Vodafone, both would have their own managed Cisco hardware, mapped with the same IP addresses, failing over to each other in the event of a network outage.' },
      { question: 'What hardware is provided for your Ethernet Leased Lines?', answer: 'Unless stated otherwise all our Ethernet Leased Lines are provided with a managed Cisco router. Which Cisco router is provided will depend on what sized Ethernet Leased Line you take in order to provide optimum performance at all times.' },
      { question: 'How are Ethernet Leased Lines monitored?', answer: 'All of our Ethernet customers Leased Lines are monitored within our NOC 24/7/365 to ensure consistency in performance and immediate response to service issues.' },
      { question: 'How long does it take to install an Ethernet Leased Line?', answer: 'Installation times are subject to survey and can change from order to order, however as standard; Ethernet First Mile can be delivered in 30 working days. Ethernet Leased line can be delivered in 60 working days.' },
      { question: 'Can our Ethernet Leased Line be upgraded?', answer: 'Our customers can upgrade their Ethernet Leased Line speeds at any point. However they may need to consider what their Ethernet Leased Line bearer speed is. For instance if you have a 10Mbps Ethernet Leased Line on a 10Mbps bearer, you are at the maximum speed of the Ethernet Leased Line already. Therefore we would need to install a new connection to meet your requirements. Upgrades are subject to increase in rental charges.' },
      { question: 'Can our existing Fibre be used at site for an Ethernet Leased Line?', answer: 'It’s standard within the industry that all quotations make the assumption that existing fibre is present and available for use to deliver an Ethernet Leased Line. A site survey will be carried out to ascertain whether the correct fibre provisions are available to use. A survey is normally completed immediately after you have placed your order for Ethernet.' },
      { question: 'What is Converged Ethernet?', answer: 'Using Converged Ethernet your business would make cost savings by consolidating voice and data. You can have full confidence in partnering with the market leader in VoIP telephony delivery.' },
      { question: 'What does un-contended Ethernet mean?', answer: 'Ethernet is provided over a dedicated network which is not shared with other businesses. This ensures that your Ethernet Leased Line offers 100% of the bandwidth you’ve been quoted, regardless of times, network restraints and other businesses’ demands.' },
      { question: 'What Ethernet Leased Line speeds are available?', answer: 'We provide Ethernet in different flavours, from 1Mbps up to 10Gbps. Ethernet First Mile range from 1Mbps to 35Mbps, depending on the distance from the exchange. Ethernet Leased lines speed typically range from 10Mbps to 10Gbps.' },
      { question: 'What is an Ethernet Leased Line?', answer: 'An Ethernet Leased Line is a dedicated connection between your premises and the internet. Unlike traditional broadband, Ethernet Leased Lines are uncontended; ensuring you get the bandwidth speeds you have subscribed to. Ethernet Leased Lines are ideal to support applications such as Voice (VoIP), video conferencing and large data transactions.' },
    ],
    selectedFaq: 0,
  }),
}
</script>
